export const loobackApiUrl = "https://a.middlewestexpress.com";
// export const loobackApiUrl = "http://127.0.0.1:3000";
export const apiUrl = "http://api.middlewestexpress.com";